import React, { useState } from "react"
import Button from "@/common/components/_UI/Button"
import Container from "@/common/components/UI/Container"
import { useTranslation } from "next-i18next"
import styled from "styled-components"

export default function TabSection({ dataId }) {
  const [activeTab, setActiveTab] = useState("1")
  const { t } = useTranslation("joinUs")

  return (
    <Container>
      <Wrapper>
        <div className="tabs">
          {dataId.map(({ id, title, tab }) => (
            <TabButtons
              key={id}
              title={t(title)}
              tab={tab}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          ))}
        </div>
        <div className="content">
          {dataId.map(({ id, tab, content }) => (
            <div key={id}>{activeTab === tab && <div>{content}</div>}</div>
          ))}
        </div>
      </Wrapper>
    </Container>
  )
}

const TabButtons = ({ tab, mr, title, activeTab, setActiveTab }) => {
  return (
    <Button
      type={activeTab === tab ? "" : "secondary"}
      content={title}
      onClick={() => setActiveTab(tab)}
    />
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  .tabs {
    display: flex;
    justify-content: center;
    gap: 24px;
    min-width: 100%;
    .tabButton {
      width: 250px;
    }
    @media (max-width: 800px) {
      justify-content: center !important;
      overflow: visible;
      flex-wrap: wrap;
      .tabButton {
        flex: 1 1 100%;
        padding: 10px 15px;
        min-width: 0px;
        background-color: none !important;
        box-shadow: none;
        transform: scale(1) !important;
        &:hover,
        &:active {
          box-shadow: none;
          transform: scale(1) !important;
        }
        .btn-text {
          word-wrap: break-word;
        }
      }
    }
  }
  .content {
    width: 100%;
  }
`
